// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Icons
import IconEmptyBox from 'ui/Icons/IconEmpty'

// Styles
import './Empty.scss'

function Empty({ message }) {
  return (
    <div className="x-empty">
      <IconEmptyBox />
      <p className="--message">{message}</p>
    </div>
  )
}

Empty.propTypes = {
  message: PropTypes.string,
}

Empty.defaultProps = {
  message: 'No Data',
}

export default Empty
